import axios from "axios";
import { getConfig } from '../helpers/config';

export class RevocheService {

    baseAPIUrl = `${getConfig()?.url}revoche`;

    getById = async (id) => {
        return await axios.get(`${this.baseAPIUrl}/${id}`)
            .then(res => res.data);
    }

    getAllDt = async (data) => {
        return await axios.post(`${this.baseAPIUrl}/dt`, data)
            .then(res => res.data);
    }

    create = async (data,file) => {

        try {
            const formData = new FormData();
            formData.append("file", file);
            for ( var key in data ) {
                formData.append(key, data[key]);
            }
            formData.append("gruppo",data);

            const response = await axios.post(`${this.baseAPIUrl}/`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        } catch (error) {
            console.error("Errore durante l'invio del file CSV:", error);
            throw error;
        }

        /*return await axios.post(`${this.baseAPIUrl}/`, data)
            .then(res => res.data);*/
    }

    update = async (data) => {
        return await axios.put(`${this.baseAPIUrl}/`, data)
            .then(res => res.data);
    }

    delete = async (id) => {
        return await axios.delete(`${this.baseAPIUrl}/${id}`)
            .then(res => res.data);
    }

    getAll = async () => {
        return await axios.get(`${this.baseAPIUrl}/`).then(res => res.data);
    }

    getAllByBandoId = async (bandoId) => {
        return await axios.get(`${this.baseAPIUrl}/bando/${bandoId}`).then(res => res.data);
    }
    invia = async (id) => {
        return await axios.put(`${this.baseAPIUrl}/${id}/invia`,null).then(res => res.data);
    }
}
